<template>
    <div class="group_list">

        <div class="btn-group choice_region">
            <button type="button" v-for="item in filter_group_draw" class="btn btn-outline-primary waves-effect waves-themed" :class="class_filter_type(item)"  @click.prevent="set_active_filter_group(item)" >
                {{item.name}}
            </button>
        </div>

        <div class="panel-tag mt-2 mb-2">
            <div id="js_change_tab_direction" class="btn-group btn-group-sm btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-success waves-effect waves-themed cursor-pointer"  v-on:click="check_uncheck(false)" data-action="" data-class="" data-target="">
                    <input type="radio" name="radioNameTabDirection" value="nav nav-tabs justify-content-end"> {{__t("UNSELECT_ALL")}}
                </label>
            </div>
            <div class="badge badge-primary float-right">{{ __t('GROUP_LIST_COUNT') }} {{ grouplist.length  }} </div>
        </div>

        <div class="load_user pt-3" v-if="is_load">
            <div class="text-center">
                <b-spinner variant="warning" label="Text Centered"></b-spinner>

            </div>
        </div>

        <groups_list :groups="grouplist"></groups_list>
    </div>
</template>

<script>
import {createHelpers} from 'vuex-map-fields';
import Groups_list from "../list/groups_list.vue";
const {mapFields} = createHelpers({
    getterType: 'groups/getUfilterField',
    mutationType: 'groups/updateUfilterField',
});


export default {
    name: "modifiers_groups_filter",
    components: {Groups_list},
    data() {
        return {
            form: {},
            is_load: false,
            is_check_active: false,

            active_filter_type : "all",

            filter_group : [
                {
                    'name' : this.__t('ALL'),
                    'type' : 'all'
                },

                {
                    'name' : this.__t('REQUIRED'),
                    'type' : 'required'
                },

                {
                    'name' : this.__t('NOT_REQUIRED'),
                    'type' : 'not_required'
                },

                {
                    'name' : this.__t('WITH_PRODUCTS_ONLY'),
                    'type' : 'with_products_only'
                },
            ]
        }
    },

    created() {
        this.set_active_filter_group({'type' :this.filter_type});
    },

    methods: {

        set_active_filter_group(filter_group) {
            this.active_filter_type = filter_group.type;
            this.load_all_groups();
        },

        class_filter_type(item) {
            if(item.type == this.active_filter_type) {
                return 'active';
            }
            return  '';
        },

        check_uncheck(state) {
            EventBus.$emit('check_list', {active: state});
        },

        check_all() {
            this.is_check_active = !this.is_check_active;
            EventBus.$emit('check_list', {active: this.is_check_active});
        },

        async load_all_groups() {
            this.is_load = true;
            this.groups = [];
            await api.post('/internal/v1/catalog/modifiers/groups',{
                'filter_type' : this.active_filter_type
            }).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.$store.dispatch('groups/SET_GROUPS_LIST', data.data);
                }
            }).catch(({response}) => {
                this.is_load = false;
                this.$store.dispatch('groups/SET_GROUPS_LIST', []);
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },

    computed: {
        ...mapFields([
            'groups',
            'filter_type',
        ]),

        filter_group_draw() {
            return this.filter_group;
        },

        grouplist () {
            return  this.groups;
        },
    }
}
</script>


<style scoped>

</style>
